import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { getDateStringFromTimestamp } from '../../helper';
import Banner from '../Banner';
import classes from './style.module.scss';

const Seller = ({
    openCancelVacationPopup, allowContact, endDate,
    startDate, openPopup = () => null
}) => {
    const currentlyInVacation = startDate <= new Date().getTime();

    const title = !currentlyInVacation ? (
        <I18n k="out_of_office.banner.new_seller.you_will_be_unavailable_from" params={{ startDate: getDateStringFromTimestamp(startDate) }}/>
    ) : (
        <I18n k="out_of_office.banner.new_seller.unavailable_until" params={{ endDate: getDateStringFromTimestamp(endDate) }}/>
    );

    const text = allowContact ? (
        <I18n k="out_of_office.banner.new_seller.you_allow_contact"/>
    ) : (
        <I18n k="out_of_office.banner.new_seller.you_disallowed_contact"/>
    );

    return (
        <Banner title={title}
            text={text}>
            {startDate && (
                <footer className={classNames('m-t-12 flex flex-col flex-items-center', classes.buttons)}>
                    <Button onClick={(e) => openPopup(e, 'seller_page')} intent="secondary" variant="outline" size="sm">
                        <I18n k="out_of_office.general.edit"/>
                    </Button>
                    {currentlyInVacation && (
                        <Button intent="secondary" variant="outline" size="sm" onClick={openCancelVacationPopup}>
                            <I18n k="out_of_office.banner.new_seller.set_to_available"/>
                        </Button>
                    )}
                </footer>
            )}
        </Banner>
    );
};

Seller.propTypes = {
    endDate: PropTypes.number,
    startDate: PropTypes.number,
    allowContact: PropTypes.bool,
    openCancelVacationPopup: PropTypes.func,
    openPopup: PropTypes.func
};

export default Seller;
